import { render, staticRenderFns } from "./SanteDeces.vue?vue&type=template&id=a6238b0a&"
import script from "./SanteDeces.vue?vue&type=script&lang=js&"
export * from "./SanteDeces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports